import type { ReactElement } from "react";

import type { BodyProps } from "@/types";
import { mergeSx } from "@/utils";
import { Body } from "../Text/Body";
import { adornmentSx } from "./styles";

export type TextInputAdornmentProps<
  RC extends ReactElement | undefined = undefined,
> = BodyProps<RC> & {};

export function TextInputAdornment<
  RC extends ReactElement | undefined = undefined,
>({ children, sx, ...props }: TextInputAdornmentProps<RC>) {
  const allStyles = mergeSx(adornmentSx, sx);

  return (
    <Body {...props} sx={allStyles}>
      {children}
    </Body>
  );
}

TextInputAdornment.displayName = "TextInput.Adornment";
